import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '#/modules/commonComponents/tabs';
import PageShell from '#/modules/infra/layout/PageShell';
import MaterialShortageListPage from '#/modules/momMgmt/analysis/materials/pages/MaterialShortageListPage';
import WorkOrderStatusPage from '#/modules/momMgmt/analysis/orders/pages/WorkOrderStatusPage';

const ANALYSIS_TAB = {
  ORDERS: 'orders',
  MATERIALS: 'materials',
};

function resolveAnalysisTab(raw) {
  if (raw === ANALYSIS_TAB.MATERIALS) {
    return ANALYSIS_TAB.MATERIALS;
  }
  return ANALYSIS_TAB.ORDERS;
}

/**
 * 分析單頁殼：Tabs（工單狀態／物料缺口）＋ `?tab=`。
 */
const AnalysisShellPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = useMemo(
    () => resolveAnalysisTab(searchParams.get('tab')),
    [searchParams],
  );

  function handleTabChange(nextTab) {
    const resolved = resolveAnalysisTab(nextTab);
    setSearchParams({ tab: resolved }, { replace: true });
  }

  return (
    <PageShell variant="listWithSide">
      <div className="layout-shell__body min-h-0">
        <Tabs
          value={tab}
          onValueChange={handleTabChange}
          className="flex min-h-0 flex-1 flex-col gap-0"
        >
          <div className="flex shrink-0 flex-wrap items-start gap-2">
            <h1 className="page_title shrink-0">
              <span className="border-l-5 border-primary-400 pl-2.5">分析</span>
            </h1>
            <TabsList className="shrink-0 flex-wrap justify-start bg-slate-200 p-1">
              <TabsTrigger value={ANALYSIS_TAB.ORDERS}>工單狀態</TabsTrigger>
              <TabsTrigger value={ANALYSIS_TAB.MATERIALS}>物料缺口</TabsTrigger>
            </TabsList>
          </div>

          <TabsContent
            value={ANALYSIS_TAB.ORDERS}
            className="mt-0 flex min-h-0 flex-1 flex-col outline-none"
          >
            <WorkOrderStatusPage />
          </TabsContent>
          <TabsContent
            value={ANALYSIS_TAB.MATERIALS}
            className="mt-0 flex min-h-0 flex-1 flex-col outline-none"
          >
            <MaterialShortageListPage />
          </TabsContent>
        </Tabs>
      </div>
    </PageShell>
  );
};

export default AnalysisShellPage;
